const sendPasswordReset = `query reset($email: String!) {
    sendPasswordReset(email: $email)
}`;
export default sendPasswordReset;